import { render, staticRenderFns } from "./addCompany.vue?vue&type=template&id=196a3d73&scoped=true"
import script from "./addCompany.vue?vue&type=script&lang=js"
export * from "./addCompany.vue?vue&type=script&lang=js"
import style0 from "./addCompany.vue?vue&type=style&index=0&id=196a3d73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a3d73",
  null
  
)

export default component.exports